export default "__VITE_ASSET__C1wO_aNq__"